import { render, staticRenderFns } from "./AccountRoles.vue?vue&type=template&id=5f983b4b"
import script from "./AccountRoles.vue?vue&type=script&lang=js"
export * from "./AccountRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports